import Api from "shared/service/api/api";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    isLoaded: false,
    list: [],
    page: 0,
    pageCount: null,
    searchLast: null,
  },
  actions: {
    loadList({ state, commit }, { search = ""}) {
      if (state.isLoaded && search !== state.searchLast) {
        commit('reset');
      }

      if (state.page === state.pageCount || state.isLoading) {
        return;
      }

      state.page++;
      state.isLoading = true;
      state.isLoaded = false;
      state.searchLast = search;

      Api.multimedia.video
        .getList(state.page, search)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          state.list.push(...response.data.list);
          state.page = response.data.page;
          state.pageCount = response.data.page_count;
          state.isLoaded = true;
        })
        .catch((e) => e)
        .finally(() => (state.isLoading = false));
    }
  },
  mutations: {
    reset(state) {
      state.list = [];
      state.page = 0;
      state.pageCount = null;
    },
  }
};
